import { IndexeddbPersistence } from 'y-indexeddb';

const DB_NAME = 'memo-v2-yjs';

export function createLocalPersistence(doc) {
  const persistence = new IndexeddbPersistence(DB_NAME, doc);

  persistence.on('synced', () => {
    console.log('[y-indexeddb] synced');
  });

  return persistence;
}

export function clearLocalPersistence() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.deleteDatabase(DB_NAME);
    req.onsuccess = resolve;
    req.onerror = () => reject(req.error);
  });
}
